import { render, staticRenderFns } from "./CourseQuestionDetail.vue?vue&type=template&id=1fb11761&"
import script from "./CourseQuestionDetail.vue?vue&type=script&lang=js&"
export * from "./CourseQuestionDetail.vue?vue&type=script&lang=js&"
import style0 from "./CourseQuestionDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports